import { createSlice } from "@reduxjs/toolkit";
import { fetchTaskerProfiles, getTaskerDetails, getTaskerProfile, contactUs } from "../thunks/userThunks";

const userSlice = createSlice({
  name: "user",
  initialState: {
    taskerProfiles: {
      profiles: [],
      pagination: {},
    },
    taskerProfile: {
      profile: {},
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTaskerProfiles.fulfilled, (state, action) => {
      state.taskerProfiles.profiles = action.payload.data?.data || [];
      state.taskerProfiles.pagination = action.payload.data?.pagination || {};
    });

    builder.addCase(getTaskerDetails.fulfilled, (state, action) => {
      state.taskerProfile.profile = action.payload.data?.data[0] || {};
      console.log("Fetching tasker details");
    });

    builder.addCase(getTaskerProfile.fulfilled, (state, action) => {
      console.log("Fetching tasker profile");
    });

    builder.addCase(contactUs.fulfilled, (state, action) => {
      console.log("Contact us success");
    });
  },
});

export default userSlice.reducer;
